import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    persons: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_PERSONS:
            return Object.assign({}, state, {
                persons: action.payload
            });
        default:
            return state
    }
}